module.exports = __webpack_public_path__ + "img/tp-5.5355fd34.png";